<template>
<el-form-item prop="duration" label="轨迹时长" :rules="[{
  required: true,
  message: '请输入轨迹时长'
}]">
  <el-radio-group v-model="durationValue" @change="onDurationValueChange">
    <el-radio
      v-for="duration in durations"
      :key="duration.value"
      :label="duration.value"
    >{{duration.label}}</el-radio>
    <div style="margin-top:10px;">
      <el-radio label="" class="custom-duration-radio">
        <el-input v-model="durationInput" type="number" :disabled="!!durationValue" style="width:233px;" @change="onDurationInputChange">
          <template #append>小时</template>
        </el-input>
      </el-radio>
    </div>
  </el-radio-group>
</el-form-item>
</template>

<script>
import Option from './Option'

import BaseHySplit from './BaseHySplit'

const {durations} = Option

export default {
  name: 'DurationSelector',
  extends: BaseHySplit,
  data: () => ({
    durationValue: durations[0].value,
    durationInput: 7 * 24
  }),
  computed: {
    durations: () => durations
  },
  methods: {
    onDurationValueChange (durationValue) {
      if (durationValue) {
        this.model.duration = durationValue
      } else {
        this.onDurationInputChange()
      }
    },
    onDurationInputChange () {
      let durationInput = parseInt(this.durationInput)
      this.model.duration = Number.isFinite(durationInput) ? durationInput : ''
    }
  },
  created () {
    this.onDurationValueChange(durations[0].value)
  }
}
</script>

<style lang="scss" scoped>
.custom-duration-radio {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/04HYSPLIT/DurationSelector.vue